export class StreamCursorResetRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "topicPartition",
            "baseName": "topicPartition",
            "type": "KafkaTopicPartition",
            "format": ""
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "StreamCursorResetRequestToEnum",
            "format": ""
        },
        {
            "name": "offset",
            "baseName": "offset",
            "type": "string",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StreamCursorResetRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var StreamCursorResetRequestToEnum;
(function (StreamCursorResetRequestToEnum) {
    StreamCursorResetRequestToEnum["LogStart"] = "LOG_START";
    StreamCursorResetRequestToEnum["Offset"] = "OFFSET";
})(StreamCursorResetRequestToEnum || (StreamCursorResetRequestToEnum = {}));
